import React from 'react';
import { render } from 'react-dom';

import { syncTranslationWithStore } from 'react-redux-i18n';
import { Provider } from 'react-redux';
import 'font-awesome/css/font-awesome.css';
import 'flexboxgrid/css/flexboxgrid.css';
import './styles/css/styles.css';

import store from './store';
import { AUTH_USER } from './redux/actions/types/authTypes';
import { getAuthUser } from './redux/actions/authActions';
import { setLanguage } from './redux/actions/userActions';

import Root from './components/Root';
import Routes from './routes';

syncTranslationWithStore(store);
setLanguage()(store.dispatch);

const user = getAuthUser();
if (user) store.dispatch({ type: AUTH_USER, result: { user } });

render(
  <Provider store={store}>
    <Root>
      <Routes />
    </Root>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js